import React from 'react';
import Head from 'next/head';

import PageLayout from '../src/components/layout/PageLayout';
import i18n from '../src/translations/i18n';

export default props => {
    return (
        <>
            <Head>
                <title>Managed Xcalibra Website – Privacy Policy January 12, 2024</title>
            </Head>
            <PageLayout title={'Managed Xcalibra Website – Privacy Policy January 12, 2024'} {...props}>
                <div>
                        <p>This Privacy Policy applies only to Clients of Xcalibra AG, Switzerland and the Managed.Xcalibra.com website.</p>

                        <h4 id="xcalibra-account-and-access-to-xcalibra-services">
                            Who are we?
                        </h4>
                        <p>
                            We are Xcalibra AG (“Our Company”), a company limited by shares with domicile in Zug, Switzerland.
                            This privacy policy will explain how we use the personal data we collect from you (“You”) when You
                            use our website. Responsible for the data processing is Xcalibra AG, c/o Dr. J. Bollag & Cie. AG,
                            Unter Altstadt 10, 6302 Zug, Switzerland.
                        </p>
                        <h4 id="xcalibra-account-and-access-to-xcalibra-services">
                            What data do we collect?
                        </h4>
                        <p>
                            Our Company collects the following data:
                        </p>
                        <ol>
                            <li>
                                <p>
                                    Data that identifies you (name, surname, email address, IP address, device and
                                    browser type, etc.)
                                </p>
                            </li>
                            <li>
                                <p>
                                    Marketing data (your email address that we use for a newsletter, whether you
                                    opened and clicked on links in the email, etc.)
                                </p>

                            </li>
                            <li>
                                <p>
                                    Financial information (your bank account information, wallet adress).
                                </p>
                            </li>
                        </ol>
                        <h4 id="xcalibra-account-and-access-to-xcalibra-services">
                            How do we collect your data?
                        </h4>
                        <p>
                            You directly provide Our Company with most of
                            the data we collect. We collect data and process data when You:
                        </p>
                        <ol>
                            <li>
                                <p>
                                    Register online and submit your KYC information
                                </p>
                            </li>
                            <li>
                                <p>
                                    Voluntarily complete a customer survey or provide feedback
                                    on any of our message boards or via email.
                                </p>
                            </li>
                            <li>
                                <p>
                                    Use or view our website via your browser and web cookies.
                                </p>
                            </li>

                        </ol>
                        <h4 id="xcalibra-account-and-access-to-xcalibra-services">
                            How will we use your personal data?
                        </h4>
                        <p>
                            Our Company collects your data so that we can:
                        </p>
                        <ol>
                            <li>
                                <p>
                                    To open your account
                                </p>
                            </li>
                            <li>
                                <p>
                                    To process your order and administer your account
                                </p>
                            </li>
                            <li>
                                <p>
                                    Email you with special offers on other products and services we think you might like
                                </p>
                            </li>
                        </ol>
                        <p>
                            When Our Company processes your data, it may send your data to, and also use the
                            resulting information from, compliance service providers to prevent fraud or money laundering.
                        </p>
                        <p>
                            Our Company may share your personal data with other relevant third parties,
                            in particular if we are requested to do so to comply with a court order or
                            law enforcement request, or if we deem it necessary, as determined at our
                            sole discretion, to investigate, prevent or take action against illegal activities.
                        </p>
                        <h4 id="xcalibra-account-and-access-to-xcalibra-services">
                            How do we store your data?
                        </h4>
                        <p>
                            Our Company applies high industry standards and will always apply
                            adequate technical and organisational measures, in accordance with
                            applicable laws to ensure that your data is kept secure.
                        </p>
                        <p>
                            Our Company securely stores your data in
                            Zurich, Switzerland and follows the most advanced security measures.
                        </p>
                        <p>
                            Our Company will keep your data for two years. Once
                            this time period has expired, we will delete your data.
                        </p>
                        <h4 id="xcalibra-account-and-access-to-xcalibra-services">
                            Marketing
                        </h4>
                        <p>
                            Our Company would like to send
                            You information about products and services of ours that we think You might like.
                        </p>
                        <p>
                            If You have agreed to receive marketing, You may always opt out at a later date.
                        </p>
                        <p>
                            You have the right at any time to stop Our Company from contacting You for marketing purposes.
                        </p>
                        <p>
                            If You no longer wish to be contacted for marketing purposes, please send an
                            email to <strong>contacts@xcalibra.com</strong> OR click the unsubscribe link that may be present in an email.
                        </p>
                        <h4 id="xcalibra-account-and-access-to-xcalibra-services">
                            What are your data protection rights?
                        </h4>
                        <p>
                            Our Company would like to make sure You are fully aware of all of
                            your data protection rights. Every customer is entitled to the following:
                        </p>
                        <ol>
                            <li>
                                <p>
                                    <strong>The right to access</strong> – You have the right to request Our Company for
                                    copies of your personal data. We may charge You a small fee for this service.
                                </p>
                            </li>
                            <li>
                                <p>
                                    <strong>The right to rectification</strong> – You have the right to request that
                                    Our Company corrects any information You believe is inaccurate.
                                    You also have the right to request Our Company to complete the
                                    information You believe is incomplete.
                                </p>
                            </li>
                            <li>
                                <p>
                                    <strong>The right to erasure</strong> – You have the right to request that
                                    Our Company erases your personal data, under certain conditions.
                                </p>
                            </li>
                            <li>
                                <p>
                                    <strong>The right to restrict processing</strong> – You have the right to request
                                    that Our Company restricts the processing of your personal data,
                                    under certain conditions.
                                </p>
                            </li>
                            <li>
                                <p>
                                    <strong>The right to object to processing</strong> – You have the right to object
                                    to Our Company’s processing of your personal data, under certain conditions.
                                </p>
                            </li>
                            <li>
                                <p>
                                    <strong>The right to data portability</strong> – You have the right to request
                                    that Our Company transfers the data that we have collected to
                                    another organization, or directly to You, under certain conditions.
                                </p>
                            </li>
                        </ol>
                        <p>
                            If You make a request, we have one month to respond to You.
                            If You would like to exercise any of these rights, please
                            contact us at our email: privacy@xcalibra.com
                        </p>
                        <h4 id="xcalibra-account-and-access-to-xcalibra-services">
                            Cookies
                        </h4>
                        <p>
                            Cookies are text files placed on your computer to collect standard
                            Internet log information and visitor behavior information. When You
                            visit our website, we may collect information from You automatically
                            through cookies or similar technology.
                        </p>
                        <h4 id="xcalibra-account-and-access-to-xcalibra-services">
                            How do we use cookies?
                        </h4>
                        <p>
                            Our Company uses cookies in a range of ways to
                            improve your experience on our website, including:
                        </p>
                        <ol>
                            <li>
                                <p>
                                    Keeping You signed in;
                                </p>
                            </li>
                            <li>
                                <p>
                                    Understanding how You use our website;
                                </p>
                            </li>
                            <li>
                                <p>
                                    Understand the geographical composition of our community;
                                </p>
                            </li>
                        </ol>
                        <h4 id="xcalibra-account-and-access-to-xcalibra-services">
                            What types of cookies do we use?
                        </h4>
                        <p>
                            There are a number of different types of cookies, however, our website uses:
                        </p>
                        <ol>
                            <li>
                                <p>
                                    Functionality – Our Company uses these cookies so that we
                                    recognize You on our website and remember your previously
                                    selected preferences. These could include what language You
                                    prefer and location You are in. A mix of first-party and
                                    third-party cookies are used.
                                </p>
                            </li>
                            <li>
                                <p>
                                    Advertising – Our Company uses these cookies to collect information
                                    about your visit to our website, the content You viewed, the
                                    links You followed and information about your browser,
                                    device, and your IP address. Our Company sometimes
                                    shares some limited aspects of this data with third
                                    parties for advertising purposes. We may also share
                                    online data collected through cookies with our advertising
                                    partners. This means that when You visit another website,
                                    You may be shown advertising based on your browsing patterns
                                    on our website.
                                </p>
                            </li>
                        </ol>
                        <h4 id="xcalibra-account-and-access-to-xcalibra-services">
                            How to manage cookies
                        </h4>
                        <p>
                            You can set your browser not to accept cookies. However,
                            in a few cases, some of our website features may not function as a result.
                        </p>
                        <h4 id="xcalibra-account-and-access-to-xcalibra-services">
                            Privacy policy of other websites
                        </h4>
                        <p>
                            Our Company website contains links to other websites.
                            Our privacy policy applies only to our website, so if
                            You click on a link to another website, You should read
                            their privacy policy.
                        </p>
                        <h4 id="xcalibra-account-and-access-to-xcalibra-services">
                            Changes to our privacy policy
                        </h4>
                        <p>
                            Our Company keeps its privacy policy under regular review
                            and may make changes at any time without prior notice.
                            The current version published on our website shall apply.
                        </p>
                        <h4 id="xcalibra-account-and-access-to-xcalibra-services">
                            How to contact us
                        </h4>
                        <p>
                            If You have any questions about Our Company’s privacy policy,
                            the data we hold on You, or You would like to exercise one of
                            your data protection rights, please do not hesitate to contact us.
                        </p>
                        <p>
                            Email us at: <strong>privacy@xcalibra.com</strong>
                        </p>
                        <h4 id="xcalibra-account-and-access-to-xcalibra-services">
                            Jurisdiction and Governing Law
                        </h4>
                        <p>
                            This privacy policy and any questions relating thereto
                            shall be governed by the laws of Switzerland, to the
                            exclusion of any rules of conflict resulting from private
                            international law.
                        </p>
                        <p>
                            Any dispute relating to this policy must exclusively be
                            brought before the ordinary courts of Zug.
                        </p>
                </div>
            </PageLayout>
        </>
    );
};
